import createStorage from './storage';

export default createStorage(sessionStorage);
